import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
export default class LinksBlock extends Component {
  view(vnode) {
    const _vnode$attrs = vnode.attrs,
      title = _vnode$attrs.title,
      start = _vnode$attrs.start,
      end = _vnode$attrs.end,
      iconClass = _vnode$attrs.iconClass;
    const links = this.generateLinks(start, end);
    return m("div", {
      class: "foo-mid"
    }, m("div", null, m("h3", null, m("i", {
      class: iconClass
    }), " ", title), m("ul", null, links)));
  }
  generateLinks(start, end) {
    const links = [];
    for (let i = start; i <= end; i++) {
      const link = app.forum.attribute("modern-footer.link-".concat(i));
      const text = app.forum.attribute("modern-footer.text-".concat(i));
      if (link && text) {
        links.push(m("li", {
          key: link
        }, m("a", {
          href: link,
          target: this.isExternalLink(link) ? '_blank' : undefined
        }, text)));
      }
    }
    return links;
  }
  isExternalLink(link) {
    try {
      const url = new URL(link, window.location.origin);
      return this.normalizeHostname(window.location.hostname) !== this.normalizeHostname(url.hostname);
    } catch (e) {
      return false;
    }
  }
  normalizeHostname(hostname) {
    return hostname.replace(/^www\./, '');
  }
}
flarum.reg.add('huseyinfiliz-modern-footer', 'forum/components/LinksBlock', LinksBlock);